import { ConfigService } from '../../../infra/config'
import { BaseRepository } from '../../../infra/base.repository'
import type { NPS } from './nps'

export class NPSRepository extends BaseRepository<NPS> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/' + 'nps', token, cache)
    }

    async getPlace(address) {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl +
                '/nps/place/?address=' +
                encodeURIComponent(address) +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getNPSPublic(companyId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl + '/nps/' + companyId + '/public/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async updateGoogle(companyId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl + '/nps/' + companyId + '/google-sync/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
